<template>
	<span class="hover"></span>
</template>

<script>
export default {
	props: {
		copy: String
	}
}
</script>

<style lang="scss" scoped>
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}

	33% {
		border-radius: 80% 70% 80% 70% / 80% 70% 100% 70%;
	}

	66% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.hover {
	position: fixed;
	left: 0;
	top: -17px;
	pointer-events: none;
	z-index: -1;
	transform-origin: left center;;

	display: block;
	width: 65px;
	height: 62px;
	background: $colorRed1;
	border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	overflow: hidden;
	animation: border1 2s infinite linear;

}

</style>